import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ProjectedMonthlyContainer from '../containers/Report';
import AuthUserContainer from '../containers/AuthUser';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import FMPCheckbox from '../components/pureForm/FMPCheckbox';
import { getSharedStyles } from '../themes';

import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import OpacityIcon from '@material-ui/icons/Opacity';
import CaliforniaIcon from '../images/icons/california';
import DieselIcon from '../images/icons/diesel';
import Box from '@material-ui/core/Box';
import { Button } from '@material-ui/core';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EditManualInputDialog from './reports/EditManualInputDialog';
import { search as searchManualInputs } from '../modules/reports/manualInput';

export const isLocalhost = Boolean(window.location.hostname === 'localhost');

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<Typography
			component="div"
			role="tabpanel"
			hidden={value !== index}
			id={`scrollable-force-tabpanel-${index}`}
			aria-labelledby={`scrollable-force-tab-${index}`}
			{...other}
		>
			{value === index && <Box p={3}>{children}</Box>}
		</Typography>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

const styles = (theme) => ({
	...getSharedStyles(theme),
	weekendRow: {
		color: '#888',
		backgroundColor: '#f5f5f5',
	},
	totalRow: {
		borderTop: '2px solid black',
		fontWeight: 900,
		fontSize: 14,
	},
	label: {
		paddingRight: 10,
	},
	value: {
		fontWeight: 600,
	},
	avgSection: {
		padding: 30,
		textAlign: 'left',
		fontSize: 16,
	},
	sectionHeader: {
		textTransform: 'uppercase',
		fontSize: 14,
		color: '#777',
		fontWeight: 900,
		letterSpacing: 2,
		marginBottom: 20,
		marginTop: 20,
	},
	formControl: {
		marginLeft: 20,
	},
	title: {
		display: 'flex',
		alignItems: 'flex-end',
	},
	tab: {
		lineHeight: 1.3,
	},
	notes: {
		fontSize: 14,
		padding: 20,
		backgroundColor: '#fcfcfc',
		border: '1px solid #eee',
		marginBottom: 20,
	},
	noteTitle: {
		textTransform: 'uppercase',
		fontSize: 12,
		color: '#777',
		fontWeight: 100,
		letterSpacing: 2,
		marginBottom: 5,
	},
	exportButton: {
		borderRadius: '100px',
		padding: '8px 10px',
		fontSize: 12,
	},
	icon: {
		paddingRight: 5,
	},
	editableCell: {
		whiteSpace: 'nowrap',
	},
	editButton: {
		padding: 2,
		marginLeft: 4,
		color: '#bbb',
	},
	editedButton: {
		padding: 2,
		marginLeft: 4,
		color: '#666',
	},
	missingButton: {
		padding: 2,
		marginLeft: 4,
		color: theme.palette.primary.main,
	},
});

let _fieldNames = [
	'opis.ethanol.laEthCi799.avg',
	'opis.ethanol.usEthanolRinCurrent.avg',
	'opis.ethanol.usEthanolRin2024.avg',
	'opis.ethanol.usEthanolRin2025.avg',
	'opis.ethanol.usEthanolRin2026.avg',
	'opis.ethanol.usEthanolRin2027.avg',
	'opis.ethanol.d5AdvancedBiofuelRinCredit2023.avg',
	'opis.ethanol.d4BiodieselRinCredit2023.avg',
	'opis.ethanol.d5AdvancedBiofuelRinCredit2024.avg',
	'opis.ethanol.d5AdvancedBiofuelRinCredit2025.avg',
	'opis.ethanol.d5AdvancedBiofuelRinCredit2026.avg',
	'opis.ethanol.d5AdvancedBiofuelRinCredit2027.avg',
	'opis.ethanol.d4BiodieselRinCredit2024.avg',
	'opis.ethanol.d4BiodieselRinCredit2025.avg',
	'opis.ethanol.d4BiodieselRinCredit2026.avg',
	'opis.ethanol.d4BiodieselRinCredit2027.avg',
	'opis.ethanol.waEthanol.avg',
	'opis.ethanol.orEthanol.avg',
	'opis.ethanol.chiEthanol.avg',
	'opis.ethanol.nyhEthanol.avg',
	'opis.ethanol.nebEthanol.avg',
	'opis.lcfsCar.carbonIntensityPtsEthanol.avg',
	'opis.lcfsCar.carbonCredit.avg',
	'opis.caContractRackWithoutCar.losAngeles.unbrandedRackAverage.unl',
	'opis.laDieselWithoutCarClosingFields.losAngeles.unbrandedRackAverage.unl',
	'opis.caContractRackWithoutCar.losAngeles.unbrandedRackLow.unl',
	'opis.caContractRackWithoutCar.sanDiego.unbrandedRackAverage.unl',
	'opis.caContractRackWithoutCar.sanDiego.unbrandedRackLow.unl',
	'opis.caContractRackWithoutCar.sacramento.unbrandedRackAverage.unl',
	'opis.caContractRackWithoutCar.sacramento.unbrandedRackLow.unl',
	'opis.caContractRackWithoutCar.fresno.unbrandedRackAverage.unl',
	'opis.caContractRackWithoutCar.fresno.unbrandedRackLow.unl',
	'opis.lcfsCar.higherSummerVsWinterCarbRfgUnl',
	// 'opis.lcfsCar.caCcCpgGas90',
	'opis.lcfsCar.carbonCpgGasCombinedLcfsCrude.avg',
	'opis.ethanol.usAdvancedBiofuelRin2024.avg',
	'opis.ethanol.usAdvancedBiofuelRin2025.avg',
	'opis.ethanol.usAdvancedBiofuelRin2026.avg',
	'opis.ethanol.usAdvancedBiofuelRin2027.avg',
	'opis.conway.inputted.naturalGas.avg',
	// 'opis.carbon.caCarbonCpgDieselCrudCiDeficit.avg',
];

const shortHand = {
	'opis.caContractRackWithoutCar.losAngeles.pdiWithoutCar.unl': 'pdiUnleaded',
	'cmeGroup.nyHarborUlsdFutures.settlement': 'biodieselSettlement',
	'opis.lcfsCar.carbonCpgDieselCrudeCiDeficit.avg': 'carbonDieselDeficitAvg',
	'opis.wcSpot.laCarbNo2DieselSpot.avg': 'laCarbNo2DieselSpotAvg',
	'opis.laDieselWithCarClosingFields.unbrandedAverageWithCar': 'laDieselUnbrandedAvgWithCarClosing',
	'opis.wcSpot.caCiDailyBd.avg': 'caCiDailyBdAvg',
	'opis.wcSpot.caCarCarbNo2.avg': 'caCarCarbNo2Avg',
	'opis.wcSpot.caLcfsCarbDiesel.avg': 'caLcfsCarbDieselAvg',
	'opis.wcSpot.laUnlSportCarbobRegular.avg': 'laUnlSpotCarbobRegular',
	'opis.wcSpot.caUnlSpotCarbobRegularWinter.avg': 'caCarbobRegularWinter',
	'opis.wcSpot.caUnlSpotCarbobRegularSummer.avg': 'caCarbobRegularSummer',
	'opis.wcSpot.caUnlSpotCarbobRegularCurrent.avg': 'caCarbobRegularCurrent',
	'opis.wcSpot.caUnlSpotCarbobRegularHigh.avg': 'caCarbobRegularHigh',
	'opis.wcSpot.carbonCpgGas.avg': 'carbonCpgGasAvg',
	'opis.lcfsCar.carbonIntensityPtsEthanol.avg': 'ciDaily',
	'opis.lcfsCar.carbonCredit.avg': 'lcfsDaily',
	'opis.conway.inputted.naturalGas.avg': 'conwayInputtedAvg',
	'dgs.westCoast.e85Rate': 'dgsE85Rate',
};

const doNotDivideBy100 = {
	date: true,
	sources: true,
	dgsE85Rate: true,
	conwayInputtedAvg: true,
	carbonIntensityEthanol: true,
	biodieselSettlement: true,
	caCiDailyBdAvg: true,
	ciDaily: true,
	lcfsDaily: true,
	naturalGasoline: true,
	// carbonCpgGasAvg: true,
};

_fieldNames = _.keys(shortHand).concat(_fieldNames);
const s2f = {};
_.keys(shortHand).forEach((key) => {
	s2f[shortHand[key]] = key;
});

function fmt(key, v) {
	if (!_.isNumber(v)) {
		return '-';
	}

	// Everything needs to be divided by 100
	const sh = shortHand[key] || key;
	if (doNotDivideBy100[sh]) {
		return v.toFixed(6);
	}
	return (v / 100).toFixed(6);
}

class Reports extends Component {
	constructor(props) {
		super(props);

		const useSummerCar = localStorage.getItem('reports.useSummerCar') || false;
		this.state = {
			useSummerCar: useSummerCar === 'true' ? true : false,
			tabIndex: 0,
			when: moment().format('YYYY-MM'),
			//- Hand entered values (Conway, DGS) keyed by `${fieldName}|${YYYY-MM-DD}`
			manualInputs: {},
			//- Days that should have a hand entered value but don't, same keys
			missingDays: {},
			editing: null,
		};
		this.handleWhenChange = this.handleWhenChange.bind(this);
	}

	componentDidMount() {
		this.fetchReportData();
	}

	handleWhenChange(event) {
		this.setState({ when: event.target.value }, () => {
			this.fetchReportData();
		});
	}

	toggleSummer = () => {
		localStorage.setItem('reports.useSummerCar', !this.state.useSummerCar);
		this.setState({ useSummerCar: !this.state.useSummerCar }, () => {
			this.fetchReportData();
		});
	};

	getApiParams = () => {
		const { accessToken } = this.props;
		const { when, useSummerCar } = this.state;
		const whenMoment = moment(when, 'YYYY-MM');

		const params = {
			accessToken,
			fieldNames: _fieldNames,
			month: whenMoment.month(),
			year: whenMoment.year(),
			useSummerCar: useSummerCar,
		};
		return params;
	};

	fetchReportData() {
		const params = this.getApiParams();
		this.props.getProjectedMonthly({
			params,
		});

		this.props.getUpToDateMonthly({
			params,
		});

		this.fetchManualInputs();
	}

	fetchManualInputs = () => {
		const { month, year } = this.getApiParams();
		searchManualInputs({
			month,
			year,
			callback: (err, r) => {
				if (err) {
					return;
				}
				const toKey = (m) => `${m.fieldName}|${m.dayKey}`;
				this.setState({
					manualInputs: _.keyBy(r.manualInputs, toKey),
					missingDays: _.keyBy(r.missingDays, toKey),
				});
			},
		});
	};

	handleManualInputSaved = () => {
		this.setState({ editing: null });
		this.fetchReportData();
	};

	handleTabChange = (event, tabIndex) => {
		this.setState({ tabIndex });
	};

	render() {
		if (!this.props.projectedMonthly || !this.props.upToDateMonthly) {
			return null;
		}

		const { classes } = this.props;
		const { tabIndex } = this.state;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					{this.renderTitle()}
					<AppBar position="static" color="default">
						<Tabs
							value={this.state.tabIndex}
							onChange={this.handleTabChange}
							indicatorColor="primary"
							textColor="primary"
							variant="fullWidth"
							centered
						>
							<Tab
								className={classes.tab}
								label={
									<>
										End of Day
										<br />
										Ethanol Assessment
									</>
								}
								icon={<OpacityIcon />}
							/>
							<Tab
								className={classes.tab}
								label={
									<>
										Wholesale Rack
										<br />
										Gasoline Components
									</>
								}
								icon={<LocalGasStationIcon />}
							/>
							<Tab
								className={classes.tab}
								label={
									<>
										West Coast
										<br />
										Spot
									</>
								}
								icon={<CaliforniaIcon />}
							/>
							<Tab
								className={classes.tab}
								label={
									<>
										EKAE Diesel / Other
										<br />
										Pricing
									</>
								}
								icon={<DieselIcon />}
							/>
						</Tabs>
					</AppBar>

					<Paper className={classes.paper}>
						<TabPanel value={tabIndex} index={0}>
							{this.renderEndOfDayEthanol()}
						</TabPanel>
						<TabPanel value={tabIndex} index={1}>
							{this.renderWholesaleGas()}
						</TabPanel>
						<TabPanel value={tabIndex} index={2}>
							{this.renderWestCoastSpot()}
						</TabPanel>
						<TabPanel value={tabIndex} index={3}>
							{this.renderEkaeDiesel()}
						</TabPanel>
					</Paper>
				</Grid>
				<EditManualInputDialog
					open={!!this.state.editing}
					display={_.get(this.state.editing, 'display')}
					manualInput={_.get(this.state.editing, 'manualInput')}
					missingDay={_.get(this.state.editing, 'missingDay')}
					onClose={() => this.setState({ editing: null })}
					onSaved={this.handleManualInputSaved}
				/>
			</Grid>
		);
	}

	renderTitle = () => {
		const { classes } = this.props;

		//- Get the last 12 months
		const pastMonths = [];
		_.range(12).forEach((i) => {
			const m = moment().subtract(i, 'months');
			pastMonths.push({
				value: m.format('YYYY-MM'),
				display: m.format('MMMM, YYYY'),
			});
		});

		return (
			<Grid container spacing={2}>
				<Grid item md={10}>
					<Typography variant="h5" align="left" gutterBottom>
						Data Reporting
						<Select
							className={classes.formControl}
							value={this.state.when}
							onChange={(event) => this.handleWhenChange(event)}
							input={<Input id={`when`} />}
						>
							{pastMonths.map((pastMonth, i) => {
								return (
									<MenuItem key={i} value={pastMonth.value}>
										{pastMonth.display}
									</MenuItem>
								);
							})}
						</Select>
					</Typography>
				</Grid>
				<Grid item md={2} style={{ display: 'flex', marginBottom: 10 }}>
					{this.renderDownloadButton()}
				</Grid>
			</Grid>
		);
	};

	renderDownloadButton = () => {
		const { classes } = this.props;
		const { isSearching } = this.state;

		const params = this.getApiParams();
		params.downloadCsv = true;
		const request = {
			method: 'report.projectedMonthly.get',
			params,
		};

		let host = '';
		if (isLocalhost) {
			host = 'http://localhost:3700';
		}
		const downloadUrl = `${host}/api?request=${JSON.stringify(request)}`;

		return (
			<a
				href={downloadUrl}
				style={{ textDecoration: 'none', paddingRight: 5 }}
				target="_blank"
				rel="noreferrer noopener"
			>
				<Button
					className={classes.exportButton}
					variant="contained"
					color="primary"
					style={{ marginLeft: 10 }}
					disabled={isSearching}
				>
					<DownloadIcon className={classes.icon} />
					Export To CSV
				</Button>
			</a>
		);
	};

	renderEndOfDayEthanol = () => {
		const fields = [
			{ display: 'LA Daily', fieldName: 'opis.ethanol.laEthCi799.avg' },
			// { display: 'WA Daily', fieldName: 'opis.ethanol.waEthanol.avg'},
			{ display: 'OR Daily', fieldName: 'opis.ethanol.orEthanol.avg' },
			{ display: 'CHI Daily', fieldName: 'opis.ethanol.chiEthanol.avg' },
			{ display: 'NYH Daily', fieldName: 'opis.ethanol.nyhEthanol.avg' },
			{ display: 'NEB Daily', fieldName: 'opis.ethanol.nebEthanol.avg' },

			// { display: 'Current RINS', fieldName: 'opis.ethanol.usEthanolRinCurrent.avg'},
			//{ display: 'Ethanol D6 RINs 2020', fieldName: 'opis.ethanol.usEthanolRin2020.avg' },
			// { display: 'Ethanol D6  RINs 2022', fieldName: 'opis.ethanol.usEthanolRin2022.avg' },
			// { display: 'Ethanol D6  RINs 2024', fieldName: 'opis.ethanol.usEthanolRin2024.avg' },
			// { display: 'Ethanol D6  RINs 2025', fieldName: 'opis.ethanol.usEthanolRin2025.avg' },
			{ display: 'Ethanol D6  RINs 2026', fieldName: 'opis.ethanol.usEthanolRin2026.avg' },
			{ display: 'Ethanol D6  RINs 2027', fieldName: 'opis.ethanol.usEthanolRin2027.avg' },

			//{ display: 'Biofuel D5 RINs 2020', fieldName: 'opis.ethanol.usAdvancedBiofuelRin2020.avg' },
			//{ display: 'Biofuel D5 RINs 2021', fieldName: 'opis.ethanol.usAdvancedBiofuelRin2021.avg' },
			// { display: 'Biofuel D4 RINs 2023', fieldName: 'opis.ethanol.d4BiodieselRinCredit2023.avg' },
			// { display: 'Biofuel D4 RINs 2024', fieldName: 'opis.ethanol.d4BiodieselRinCredit2024.avg' },
			// { display: 'Biofuel D4 RINs 2025', fieldName: 'opis.ethanol.d4BiodieselRinCredit2025.avg' },
			{ display: 'Biofuel D4 RINs 2026', fieldName: 'opis.ethanol.d4BiodieselRinCredit2026.avg' },
			{ display: 'Biofuel D4 RINs 2027', fieldName: 'opis.ethanol.d4BiodieselRinCredit2027.avg' },
			// {
			// 	display: 'Adv Biofuel D5 RINs 2024',
			// 	fieldName: 'opis.ethanol.usAdvancedBiofuelRin2024.avg',
			// },
			// {
			// 	display: 'Adv Biofuel D5 RINs 2025',
			// 	fieldName: 'opis.ethanol.usAdvancedBiofuelRin2025.avg',
			// },
			{
				display: 'Adv Biofuel D5 RINs 2026',
				fieldName: 'opis.ethanol.usAdvancedBiofuelRin2026.avg',
			},
			{
				display: 'Adv Biofuel D5 RINs 2027',
				fieldName: 'opis.ethanol.usAdvancedBiofuelRin2027.avg',
			},

			{ display: 'CI Daily', fieldName: 'opis.lcfsCar.carbonIntensityPtsEthanol.avg' },
			//{ display: 'CPG Gas Daily Posting', fieldName: 'opis.wcSpot.carbonCpgGas.avg' },
			{ display: 'LCFS Daily Posting', fieldName: 'opis.lcfsCar.carbonCredit.avg' },
		];
		return this.renderTable(fields);
	};

	renderWholesaleGas = () => {
		const { classes } = this.props;
		const fields = [
			{
				display: 'LA UBD UNL Rack Avg',
				fieldName: 'opis.caContractRackWithoutCar.losAngeles.unbrandedRackAverage.unl',
			},
			{
				display: 'LA UBD UNL Rack Avg (Closing)',
				fieldName: 'opis.laDieselWithoutCarClosingFields.losAngeles.unbrandedRackAverage.unl',
			},
			{
				display: 'LA UBD UNL Rack Low',
				fieldName: 'opis.caContractRackWithoutCar.losAngeles.unbrandedRackLow.unl',
			},
			{
				display: 'SD UBD UNL Rack Avg',
				fieldName: 'opis.caContractRackWithoutCar.sanDiego.unbrandedRackAverage.unl',
			},
			{
				display: 'SD UBD UNL Rack Low',
				fieldName: 'opis.caContractRackWithoutCar.sanDiego.unbrandedRackLow.unl',
			},
			{
				display: 'SAC UBD UL Rack Avg',
				fieldName: 'opis.caContractRackWithoutCar.sacramento.unbrandedRackAverage.unl',
			},
			{
				display: 'SAC UBD UL Rack Low',
				fieldName: 'opis.caContractRackWithoutCar.sacramento.unbrandedRackLow.unl',
			},

			{
				display: 'Fresno UBD UL Rack Low',
				fieldName: 'opis.caContractRackWithoutCar.fresno.unbrandedRackLow.unl',
			},
			{
				display: 'CAR Cost (higher summer vs winter)',
				fieldName: 'opis.lcfsCar.higherSummerVsWinterCarbRfgUnl',
			},
			//{ display: 'LCFS Cost (Old)', fieldName: 'opis.lcfsCar.caCcCpgGas90' },
			{ display: 'LCFS Cost (New)', fieldName: 'opis.lcfsCar.carbonCpgGasCombinedLcfsCrude.avg' },

			// { display: 'Our PDI', fieldName: 'opis.caContractRackWithoutCar.losAngeles.pdiWithoutCar.unl'},
			// { display: 'LA Diesel Spot Carb No. 2', fieldName: 'opis.wcSpot.laCarbNo2DieselSpot.avg',},
			// { display: 'Cap@Rack Carb No2 Avg', fieldName: 'opis.wcSpot.caCarCarbNo2.avg',},
			// { display: 'CA LCFS Carb Diesel Avg', fieldName: 'opis.wcSpot.caLcfsCarbDiesel.avg',},
			// { display: 'DSL Crude Deficit Avg', fieldName: 'opis.lcfsCar.carbonCpgDieselCrudeCiDeficit.avg'},
			// { display : ['CGP Diesel Crud', 'Deficit Avg'], fieldName : 'opis.carbon.caCarbonCpgDieselCrudCiDeficit.avg', },
			// { display : ['CA Daily', 'BD Posting'], fieldName : 'opis.wcSpot.caCiDailyBd.avg' },
		];

		return (
			<div>
				<div className={classes.notes}>
					<div className={classes.noteTitle}>Notes</div>
					<div>All values are without CAR</div>
				</div>
				{this.renderTable(fields)}
			</div>
		);
	};

	renderWestCoastSpot = () => {
		const { classes } = this.props;
		const fields = [
			{ display: 'UNL Spot Carbob-R', fieldName: s2f['laUnlSpotCarbobRegular'] },
			// { display: 'CAR Cost Gasoline Winter', fieldName: s2f['caCarbobRegularWinter'] },
			// { display: 'CAR Cost Gasoline Summer', fieldName: s2f['caCarbobRegularSummer'] },
			{ display: 'CAR Cost Gas (Scheduled)', fieldName: s2f['caCarbobRegularCurrent'] },
			{ display: 'CAR Cost Gas (Selected)', fieldName: 'caCarbobRegularSelected' },
			// { display: 'CAR Cost Gasoline (High)', fieldName: s2f['caCarbobRegularHigh'] },
			{ display: 'LCFS Cost (for Naphtha)', fieldName: s2f['carbonCpgGasAvg'] },
			//{ display: 'PDI Price Gas (Posted)', fieldName: s2f['pdiUnleaded'] },
			{ display: 'LA UBD UNL Rack Avg (w/CAR + LCFS)', fieldName: 'laUnbrandedUnlRackAvg' },
			{ display: 'PDI Price Gas (Formula)', fieldName: 'pdiUnleadedFormula' },
			{ display: 'Paramount R. Naphtha', fieldName: 'naptha' },
			{ display: 'REG R. Naphtha', fieldName: 'regRegularNaphtha' },
			{ display: 'Natural Gasoline', fieldName: 'naturalGasoline' },
		];

		return (
			<div>
				<div className={classes.notes}>
					<div className={classes.noteTitle}>Notes</div>
					<div>
						<strong>Our PDI Gas Pricing Formula:</strong> Previous day UNL Spot Carbob + Car Cost
						(selected) + LCFS Cost + 0.025
						<br />
						<strong>Paramount R. Naphtha Formula:</strong> Current day UNL Sport Carbob + Car Cost
						(scheduled) + LCFS Cost - 0.475
						<br />
						<strong>REG R. Naphtha Formula:</strong> Current day UNL Sport Carbob - $0.95 + $0.355
						(rail freight) + $0.10 (LF (formerly NCP) GM)
						<br />
						<strong>CAR Cost Gas(Scheduled):</strong> 5/1 through 10/31 use Summer posting,
						otherwise use Winter posting
						<br />
						<strong>CAR Cost Gas(Selected):</strong> Use Summer vs Winter based on checkbox below
						<br />
						<strong>Conway (computed):</strong> Conway Price + LCFS Cost (wholesale tab) + 0.685
					</div>
				</div>
				<div>
					<FMPCheckbox
						path={'useSummerCar'}
						onChange={this.toggleSummer}
						value={'useSummerCar'}
						checked={this.state.useSummerCar}
						label={'Use OPIS Summer posting for "selected" CAR Cost'}
					/>
				</div>
				{this.renderTable(fields)}
			</div>
		);
	};

	renderEkaeDiesel = () => {
		const fields = [
			{ display: 'LA Diesel Spot Carb No2 Avg', fieldName: s2f['laCarbNo2DieselSpotAvg'] },
			{
				display: 'Cap at the Rack Carb No2 Avg',
				fieldName: s2f['caCarCarbNo2Avg'],
			},
			{
				display: 'CA LCFS Carb Diesel Avg',
				fieldName: s2f['caLcfsCarbDieselAvg'],
			},
			{
				display: 'CGP Diesel Crud Deficit Avg',
				fieldName: s2f['carbonDieselDeficitAvg'],
			},

			{ display: 'CI Daily DB Posting Avg', fieldName: s2f['caCiDailyBdAvg'] },
			//{ display: 'Heating Oil CME Group', fieldName: s2f['biodieselSettlement'] },
			{ display: 'Conway Posting', fieldName: s2f['conwayInputtedAvg'], editable: true },
			{ display: 'DGS E85 Rate', fieldName: s2f['dgsE85Rate'], editable: true },
		];
		return this.renderTable(fields);
	};

	//- Days with an entered value get a grey pencil to correct it. Days the backend says are
	//- missing a value (past weekdays for Conway, one day per empty week for DGS) get a blue
	//- pencil to add it. Weekends and projected days just repeat the last entry, so no pencil.
	renderEditButton = (field, dayKey) => {
		const { classes, canMakeUpdates, isExternalReporting } = this.props;
		if (!canMakeUpdates || isExternalReporting) {
			return null;
		}
		const key = `${field.fieldName}|${dayKey}`;
		const manualInput = this.state.manualInputs[key];
		const missingDay = this.state.missingDays[key];

		if (!manualInput && missingDay) {
			return (
				<Tooltip title="No value entered for this day. Click to add it.">
					<IconButton
						className={classes.missingButton}
						onClick={() => this.setState({ editing: { display: field.display, missingDay } })}
					>
						<EditIcon style={{ fontSize: 14 }} />
					</IconButton>
				</Tooltip>
			);
		}
		if (!manualInput) {
			return null;
		}

		const lastEdit = _.last(_.filter(manualInput.edits, (e) => e.oldValue !== null));
		const addedLater = _.find(manualInput.edits, { oldValue: null });
		let tooltip = `Entered by ${manualInput.createdByName || 'unknown'}`;
		if (addedLater) {
			tooltip = `Added later by ${addedLater.editedByName || 'unknown'} ${moment(
				addedLater.dateCreated
			).format('M/D h:mm a')}`;
		}
		if (lastEdit) {
			tooltip += `, edited by ${lastEdit.editedByName || 'unknown'} ${moment(
				lastEdit.dateCreated
			).format('M/D h:mm a')} (was ${lastEdit.oldValue})`;
		}

		return (
			<Tooltip title={tooltip}>
				<IconButton
					className={lastEdit ? classes.editedButton : classes.editButton}
					onClick={() => this.setState({ editing: { display: field.display, manualInput } })}
				>
					<EditIcon style={{ fontSize: 14 }} />
				</IconButton>
			</Tooltip>
		);
	};

	renderTable = (fields) => {
		const {
			classes,
			projectedMonthly,
			upToDateMonthly,
			// priorWeek,
			// priorMondayThroughFriday,
			// currentMonthly
		} = this.props;

		const columnData = [{ id: 'date', label: 'Date' }];

		fields.forEach((field) => {
			const { display } = field;

			const words = display.split(/ /);
			// Every 10 letters make a new row

			const lines = [[]];
			let currentLine = 0;
			let count = 0;
			words.forEach((word) => {
				count += word.length;
				if (count > 10) {
					count = 0;
					currentLine++;
					lines[currentLine] = [];
				}

				lines[currentLine].push(word);
			});

			const label = lines.map((words, i) => {
				return <div key={`${display}_${i}`}>{words.join(' ')}</div>;
			});
			columnData.push({ id: field.fieldName || display, label });
		});

		//const now = moment().format('YYYY-MM-DD');
		const rows = projectedMonthly.dataRows.map((dataRow) => {
			const date = moment(dataRow.date);
			const isWeekend = date.day() === 0 || date.day() === 6;
			const row = {
				dayKey: dataRow.date,
				date: date.format('ddd, M/D/YY'),
				isWeekend: isWeekend ? 'weekend' : '',
			};

			fields.forEach((field) => {
				const { fieldName } = field;
				row[fieldName] = dataRow[fieldName] || '-';
			});
			return row;
		});

		const pmm = projectedMonthly.projectedMonthlyMean;
		const totalRow = {};
		fields.forEach((field) => {
			const { fieldName } = field;
			totalRow[fieldName] = fmt(fieldName, pmm[fieldName]);
		});

		const umm = upToDateMonthly.upToDateMonthlyMean;
		const totalUpToDateRow = {};
		fields.forEach((field) => {
			const { fieldName } = field;
			totalUpToDateRow[fieldName] = fmt(fieldName, umm[fieldName]);
		});

		return (
			<Table stickyHeader size="small">
				<TableHead>
					<TableRow>
						{columnData.map((column) => {
							return <TableCell key={column.id}>{column.label}</TableCell>;
						}, this)}
					</TableRow>
				</TableHead>
				<TableBody>
					{rows.map((n, i) => {
						return (
							<TableRow key={i} className={n.isWeekend && classes.weekendRow}>
								<TableCell>{n.date}</TableCell>
								{fields.map((field, i) => {
									const value = fmt(field.fieldName, n[field.fieldName]);
									if (field.editable) {
										return (
											<TableCell key={i} className={classes.editableCell}>
												{value}
												{this.renderEditButton(field, n.dayKey)}
											</TableCell>
										);
									}
									return <TableCell key={i}>{value}</TableCell>;
								})}
							</TableRow>
						);
					})}

					<TableRow key={'totalRowProj'} className={classes.totalRow}>
						<TableCell className={classes.totalRow}>
							Projected
							<br />
							Monthly
						</TableCell>
						{fields.map((field, i) => {
							return (
								<TableCell key={`proj_${i}`} className={classes.totalRow}>
									{totalRow[field.fieldName]}
								</TableCell>
							);
						})}
					</TableRow>

					<TableRow key={'totalRowAvg'} className={classes.totalRow}>
						<TableCell className={classes.totalRow}>
							Month To Date
							<br />
							Average
						</TableCell>
						{fields.map((field, i) => {
							return (
								<TableCell key={`avg_${i}`} className={classes.totalRow}>
									{totalUpToDateRow[field.fieldName]}
								</TableCell>
							);
						})}
					</TableRow>
				</TableBody>
			</Table>
		);
	};
}

Reports.propTypes = {
	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	getProjectedMonthly: PropTypes.func.isRequired,
	getUpToDateMonthly: PropTypes.func.isRequired,
	projectedMonthly: PropTypes.object,
	upToDateMonthly: PropTypes.object,
	accessToken: PropTypes.string,
	canMakeUpdates: PropTypes.bool,
	isExternalReporting: PropTypes.bool,

	// getPriorWeek: PropTypes.func.isRequired,
	// getPriorMondayThroughFriday: PropTypes.func.isRequired,
	// getCurrentMonthly: PropTypes.func,
	// currentMonthly: PropTypes.object,
	// priorWeek: PropTypes.object,
	// priorMondayThroughFriday: PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	ProjectedMonthlyContainer,
])(Reports);
